import { render, staticRenderFns } from "./TeacherNotificationDetail.vue?vue&type=template&id=cf776536"
import script from "./TeacherNotificationDetail.vue?vue&type=script&lang=js"
export * from "./TeacherNotificationDetail.vue?vue&type=script&lang=js"
import style0 from "./TeacherNotificationDetail.vue?vue&type=style&index=0&id=cf776536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports